import React, {useEffect} from "react";
import {  NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import palette from 'utils/styles/palette.js';

import Path from 'routes/Path.jsx'
import {ReactComponent as LogoImg} from "assets/images/logo.svg";
// import logoImg from "assets/images/logo.png";

import 'assets/css/Bootstrap.min.css.map';
import 'assets/css/Bootstrap.min.css';// eslint-disable-next-line
import 'assets/css/MainLayout.css';
import 'assets/css/Layout.css';
import useLogin from "hooks/useLogin";


export default function Header () {

  const {isLogin, loginState, doLogout, moveToLogin} = useLogin();
  const system = loginState ? loginState.authTypes.includes("SYSTEM") : false;

  useEffect(()=>{
    if (!isLogin) {
      moveToLogin();
    }
  }, [isLogin]);

  return (
    <header style={{borderBottom:"1px solid #424242"}} >
      <div>
        <div style={{
          width: '100%',
          height: '40px',
          background: palette.headerTop,
        }}>
          <Button variant="loginBox" onClick={doLogout}>로그아웃</Button>
        </div>
        <section className="header-menu" >
          <ul style={{
              minWidth: "1680px", 
              background: palette.header,
            }}>
            <li className="header-menu-logo" style={{ 
              float: 'left',
            }}>
              <a href="/main">
                {/* <img src={logoImg} /> */}
              <LogoImg  />
              </a>
            </li>
            {Path.map(v => { 
              if(system || v.auth === "USER") 
              return (
                <li key={v.id}>
                  <NavLink
                    className={({isActive}) => [isActive ?"active": "inactive"].join(" ")}
                    to={v.path}>
                    {v.label}</NavLink>
                </li>);
            })}
          </ul>
        </section>
      </div>
    </header>
  );
  
}
const Button = styled.button`
  ${({ variant }) =>
      variant === "loginBox" &&
        css`
          background: ${palette.logout};
          color: ${palette.logoutFont};
          width: 80px;
          height: 25px;
          font-size: 12px;
          float: right;
          border-radius: 5px;
          margin-right: 7px;
          margin-top: 7px;
        `}
    `;